<div
  class="btn-group connected-fields-indicator"
  ngbDropdown
  container="body"
  *ngIf="shouldShow"
>
  <button type="button" class="btn btn-primary btn-sm" ngbDropdownToggle>
    {{ connectedFields.length }}
    <i class="fa-regular fa-link fa-fw"></i>
  </button>

  <div ngbDropdownMenu class="connected-fields-menu dropdown-menu-right">
    <div class="px-3 py-3">
      <h6 class="mb-3 font-weight-bold">
        {{ 'connectedFields.updatingFieldWillUpdate' | translate }}
      </h6>
      <div
        *ngFor="let connectedField of connectedFields; let i = index"
        class="mb-1"
      >
        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            class="custom-control-input"
            [(ngModel)]="connectedField.selected"
            [id]="componentId + '-connected-field-' + i"
          />
          <label
            class="custom-control-label mb-0 font-weight-normal"
            [attr.for]="componentId + '-connected-field-' + i"
          >
            <div>
              {{
                connectedField.objectDefinition?.name ||
                  ('shared.terms.unknown' | translate)
              }}
            </div>
            <div class="text-muted small">
              {{ connectedField | getFieldName }}
            </div>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
